import { 
  SET_LEAD_SOURCE, 
  SET_SALES_DATA, 
  SET_USERS_DATA, 
  SET_SALES_STAGE_LEAD, 
  CLEAR_SALES_DATA, 
  LOGOUT, 
  SET_SALESL2M_DATA, 
  CLEAR_L2M_DATA, 
  PROJECT_NO,   
  SET_DESIGN_STAGE_LEAD,
  SET_MEETING_TRACKER,
  SET_STAGE_REVIEW,
  MONTHLY_CONVERSION_GOAL
} from "../actions/types";

const initialState = {
  leadSource: null,
  salesData: null,
  usersData: null,
  salesStageLead: null,
  salesL2MData: null,
  projectNumber: null,
  designSummary: null,
  meetingTracker: null,
  stageReview: null,
  monthlyConversionData: null
};

const leadSourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEAD_SOURCE:
      return { ...state, leadSource: action.payload };

    case SET_SALES_DATA:
      return { ...state, salesData: action.payload };

    case PROJECT_NO:
      return { ...state, projectNumber: action.payload };

    case SET_USERS_DATA:
      return { ...state, usersData: action.payload };

    case SET_SALESL2M_DATA:
      return { ...state, salesL2MData: action.payload };

    case SET_SALES_STAGE_LEAD:
      return { ...state, salesStageLead: action.payload };

    case SET_DESIGN_STAGE_LEAD:
      return { ...state, designSummary: action.payload };

    case SET_MEETING_TRACKER:
      return { ...state, meetingTracker: action.payload };

    case SET_STAGE_REVIEW:
      return { ...state, stageReview: action.payload };

    case CLEAR_SALES_DATA:
      return { ...state, salesStageLead: null };

    case MONTHLY_CONVERSION_GOAL:  
     return { ...state, monthlyConversionData: action.payload };

    case CLEAR_L2M_DATA:
      return { ...state, salesL2MData: null };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default leadSourceReducer;